import { render, staticRenderFns } from "./FooterRegistration.vue?vue&type=template&id=4cb3194d&scoped=true&"
import script from "./FooterRegistration.vue?vue&type=script&lang=js&"
export * from "./FooterRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FooterRegistration.vue?vue&type=style&index=0&id=4cb3194d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3194d",
  null
  
)

export default component.exports